import axios from 'axios';

/**
 * Sign In to the Admin Dashboard
 */
export function login(email, password) {
  return axios.post('/auth/admin/login', { email, password });
}
